import { Either } from '@sola/schema/dotcom/helpers.js';

export type LogoProps = Omit<
  React.ComponentPropsWithoutRef<'svg'>,
  'aria-labelledby' | 'aria-hidden'
> &
  Either<
    { 'aria-hidden': true },
    Either<{ alt: string }, { 'aria-labelledby': string }>
  >;

export const Logo: React.FC<LogoProps> = ({ children, alt, ...props }) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    {alt && <title>{alt}</title>}
    {children}
  </svg>
);
